import {
    Task,
    TaskAction,
    TaskResult
} from "sharebase/domain";
import {
    ProgressService,
    ActionService
} from "phoenix/services";
import {
    ToastService,
    ActionRepository,
    TrackingService,
} from "sharebase/services";
import { TaskCommentDialog } from "../taskCommentDialog/taskCommentDialog";

require('./task-panel.styles');
const taskPanelTemplate = require('./task-panel.template');
const taskPanelButtonTemplate = require('./task-panel-button.template');

class TaskPanelButtonController implements ng.IController{
    public static $inject = [
        '$timeout',
        '$element',
        'sbaTaskPanelService'
    ];

    constructor(
        private readonly $timeout:ng.ITimeoutService,
        private readonly $element:ng.IAugmentedJQuery,
        private readonly sbaTaskPanelService:TaskPanelService
    ) {
    }

    public isTaskPanelShown = false;
    private readonly task;

    public $onChanges(changes) {
        if(changes && changes.task && changes.task.currentValue) {
            //Added a brief delay to attract user's eye when document has loaded
            this.$timeout(() => this.showTask(), 500);
        }
    }

    public $onDestroy() {
        this.sbaTaskPanelService.close();
    }

    public onTaskPanelOpened = () => {
        this.isTaskPanelShown = true;
    }

    public onTaskPanelClosed = () => {
        this.isTaskPanelShown = false;
    }

    public showTask(event?:Event) {
        if(!this.isTaskPanelShown) {
            let animationSource = (event && event.srcElement) ? event.srcElement : 'sba-task-panel-button .md-button';
            this.sbaTaskPanelService.show(this.task, animationSource, this.onTaskPanelOpened, this.onTaskPanelClosed, this.$element.parent());
        }
    }
}

export const TaskPanelButtonComponent:ng.IComponentOptions = {
	template: taskPanelButtonTemplate,
	controller: TaskPanelButtonController,
	controllerAs: 'vm',
	bindings: {
        task: '<'
	}
}

export class TaskPanelController implements ng.IController{
    private readonly task:Task;
    private readonly mdPanelRef;
    private readonly taskAction = TaskAction;

    public dueDatePhrase:string;

    public static $inject = [
        '$q',
        'pxProgressService',
        'sbActionRepository',
        'sbToastService',
        'sbaTaskCommentDialog',
        'sbTrackingService',
        'gettextCatalog'
    ];

    constructor(
        private readonly $q:ng.IQService,
        private readonly pxProgressService:ProgressService,
        private readonly sbActionRepository:ActionRepository,
        private readonly sbToastService:ToastService,
        private readonly sbaTaskCommentDialog:TaskCommentDialog,
        private readonly sbTrackingService: TrackingService,
        private readonly gettextCatalog:ng.gettext.gettextCatalog
    ) {}

    public close(){
        if(this.mdPanelRef) {
            this.mdPanelRef.close();
        }
    }

    public completeTask(action:TaskAction, event:ng.IAngularEvent) {
        this.sbTrackingService.trackClick(action);
        switch(action) {
			case TaskAction.QuickApprove1:
			case TaskAction.QuickApprove2:
			case TaskAction.ApproveWithComment:
				this.task.result = TaskResult.Positive;
				break;
			default:
            this.task.result = TaskResult.Negative;
        }
        
		return this.retrieveCompletionComment(action, event)
			.then(comment => {
				this.pxProgressService.visible = true;
                return this.task.complete(comment);
            })   
            .then(() => {
                this.sbToastService.showSimple(this.gettextCatalog.getString('The task has been successfully completed.'));
            })
			.catch(e => {
				if (e) {
					this.sbToastService.showSimple(this.gettextCatalog.getString('The task was unable to be completed.'));
                }
            })  
			.finally(() => {
                this.pxProgressService.visible = false;
                this.close();
            });
	}

	private retrieveCompletionComment(action:TaskAction, event:ng.IAngularEvent) {
		let comment = ''
		if (action !== TaskAction.QuickApprove1 && action !== TaskAction.QuickDeny1) {
			comment = this.sbActionRepository.getAction(action).label;
		}
		let p = this.$q.resolve(comment);
		if (action === TaskAction.ApproveWithComment || action === TaskAction.DenyWithComment) {
			p = this.sbaTaskCommentDialog.open(event, action);
		}
		return p;
	}
}

type PanelCallback = (...args: any[]) => void | PromiseLike<void>;

export class TaskPanelService {
    public static $inject = [
        '$mdPanel',
        '$mdMedia',
        '$timeout'
    ];

    constructor(
        private readonly $mdPanel:ng.material.IPanelService,
        private readonly $mdMedia,
        public readonly $timeout:ng.ITimeoutService
    ) {
    }

    private mdPanelRef:ng.material.IPanelRef;

    public show(task, animationSource:string | Element, onOpenFunc:PanelCallback, onCloseFunc:PanelCallback, attachTo?:ng.IAugmentedJQuery) {
        let panelPosition = this.$mdPanel.newPanelPosition()
            .absolute()
            .bottom()
            .centerHorizontally();
        let panelAnimation = this.$mdPanel.newPanelAnimation()
            .openFrom(animationSource)
            .withAnimation(this.$mdPanel.animation.SCALE)
            .closeTo(animationSource);

        let config = {
            animation: panelAnimation,
            attachTo: attachTo? attachTo : angular.element(document.body),
            bindToController: true,
            clickOutsideToClose: false,
            controller: TaskPanelController,
            controllerAs: 'vm',
            disableParentScroll: false,
            escapeToClose: true,
            zIndex:20,
            locals: {
                task: task
            },
            onDomAdded: onOpenFunc,
            onRemoving: onCloseFunc,
            panelClass: 'md-whiteframe-12dp task-panel__content-wrapper',
            position: panelPosition,
            template: taskPanelTemplate,
            trapFocus: true,
            propagateContainerEvents: true
        } as ng.material.IPanelConfig;

        this.close();
        this.mdPanelRef = this.$mdPanel.create(config);
        this.mdPanelRef.open().then(angular.noop);
    }

    public close() {
        if(this.mdPanelRef) {
            this.mdPanelRef.close();
            this.mdPanelRef.destroy();
            this.mdPanelRef = null;
        }
    }
}


// WEBPACK FOOTER //
// ./src/sharebase-app/components/task-panel/task-panel.ts